(function($) {

    'use strict';

    function Service() {

        var self = this,
            $el = null,
            $tab = $('.s-service__tab'),
            $desc = $('.s-service__text'),
            $service = null,
            options = {
                'example': null
            };

        /**
         * Generic resize
         */
        function onResize() {
          if (window.bp.getValue() !== 'xs' && window.bp.getValue() !== 'sm') {
            $tab.on('click', function(){
                $tab.removeClass('active');
                $desc.removeClass('active');
                $(this).addClass('active');
                $service = $(this).attr('data-service');
                $('[data-service-content="'+$service+'"]').addClass('active');

            });
          }
        }

        /**
         * Public constructor
         * @param  {Object} opts Options
         */
        self.initialize = function(opts) {
        //extends options
        for (var i in opts) { options[i] = opts[i];}
        
        // if (window.matchMedia("(min-width: 980px)").matches) {
            
        // }

        //*************
        window.cache.$window.on('resize', Utils.debounce(onResize, 400));
        onResize();     // initial call on load
    };

        self.initialize.apply(self, arguments);
        return self;
    }

    /* Namespace declaration */
    window.Service = Service;

}(jQuery));
